module.exports = __webpack_public_path__ + "img/heart7.1fd484c9.png";